import { getTimeLabelFromMinutes } from '../utils/calendar.utils';
import { AllocationCalendarSlot } from './allocation-view-calendar';
import { ONE_SLOT_MINUTES } from '../constants';
import { differenceInMinutes, startOfDay } from 'date-fns';
import { Moment } from 'moment';

export class SlotStartTime {
  hours: number;
  minutes: number;
}

export class Slot {
  id: number;
  name: string;
  duration: number;
  startTime: SlotStartTime;
}

export class CalendarSlot extends Slot {
  startPositionInPxs: number;
  height: number;

  constructor(params?: Slot) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class DraggableSlot extends AllocationCalendarSlot {
  offsetX: number;
  offsetY: number;
  columnIndex: number;
  x?: number;
  y?: number;

  constructor(params?: AllocationCalendarSlot) {
    super(params, null, null);
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class Dock {
  name: string;
  rules: Slot[];
}

export class DayTimeSlots {
  date: string;
  slots: TimeSlot[];
}

export class TimeSlot {
  timestamp: Moment;
  time: string;
  yPosition: number;
}

export class TimeLine extends TimeSlot {
  constructor(currentTimeInMinutes: number, oneMinutePxsHeight: number) {
    super();
    if (currentTimeInMinutes) {
      this.updateTime(currentTimeInMinutes, oneMinutePxsHeight);
    }
  }

  updateTime(currentTimeInMinutes: number, oneMinutePxsHeight: number): void {
    const now = new Date();
    const minutesSinceStartOfDay = differenceInMinutes(now, startOfDay(now));

    this.time = getTimeLabelFromMinutes(minutesSinceStartOfDay);
    this.yPosition = currentTimeInMinutes * (oneMinutePxsHeight / ONE_SLOT_MINUTES);
  }
}

export interface MouseOffsets {
  offsetX: number;
  offsetY: number;
}
